export default {
  colors: {
    text: '#000',
    background: 'white',
    primary: '#6032C7',
    darkGrey: '#585B60',
    green: '#05b993',
    purple: '#705ecf',
    pink: '#E50A68',
  },
  fonts: {
    body: 'Poppins'
  },
  a: {
    color: '#6032C7',
  },
  links: {
    a: {
       color: 'darkGrey',
       textDecoration: 'underline',
       "&:hover": {
         color: 'primary'
       }
    },
    grid: {
      boxShadow: '0px 0px 40px 0px rgba(0, 0,0, 0.1)',
      flexDirection: 'column',
      alignItems: ['center'],
      padding: '10px',
      borderRadius: '4px',
      height: '100%',
      transition: 'all .2s',
      '&:hover': {
        boxShadow: '0px 0px 40px 0px rgba(0, 0,0, 0.2)',
        transform: 'scale(1.05)',
      },
    },
  },
}
